import {useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {Content} from '../../../../_metronic/layout/components/content'
import MenuForm from './modal/MenuForm'
import MenuList from './MenuList'
import {IMenu} from './_modal'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const Menu = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedMenu, setSelectedMenu] = useState<IMenu | undefined>(undefined)

  const onSelectMenu = (menu: IMenu) => {
    setSelectedMenu(menu)
  }

  const onResetSelect = () => setSelectedMenu(undefined)

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={onResetSelect}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Create Menu
          </button>
        </div>
      </div>

      <MenuList searchTerm={searchTerm} onSelectMenu={onSelectMenu} />

      <MenuForm selectedMenu={selectedMenu} onResetSelect={onResetSelect} />
    </Content>
  )
}

export default Menu
